module.exports = __webpack_public_path__ + "static/media/mobile-android-alt.5f0e460e.svg";